import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom'; // Import BrowserRouter and Route
import Navbar from './sections/Navbar/Navbar';
import Header from './sections/Header/Header';
import About from './sections/About/About';
import Experience from './sections/Experience/Experience';
import Services from './sections/Services/Services';
import Portfolio from './sections/Portfolio/Portfolio';
import Testimonials from './sections/Testimonials/Testimonials';
import Contact from './sections/Contact/Contact';
import Footer from './sections/Footer/Footer';
import FloatingNav from './sections/FloatingNav/FloatingNav';


const App = () => {
    return (
    <Router>
      <main>
        <Navbar />
        <Header />
        <About />
        <Experience />
        <Portfolio/>
        <Services />
        <Testimonials />
        <Contact />
        <Footer />
        <FloatingNav />

      </main>
    
    </Router>
  );
};

export default App;
